module.exports = __webpack_public_path__ + "img/multiplier_128_win.bc43f39f.png";